import SessionUser from 'utils/user-storage';

export const ValidateUserLoggedByType = (userType) => SessionUser.get().TipoUsuario === userType
